import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import Select from 'app/components/Select'
import Back from 'app/components/SVGS/Back'

import './styles.scss'
const bc = 'stories-header'

class StoriesHeader extends Component {
  renderFilter() {
    const { ids, labels, value, onChange } = this.props
    return (
      <Select
        input={{
          value,
          onChange: e => onChange(e.target.value),
        }}
        className={`${bc}__select-wrapper`}
        classNameSelect={`${bc}__select`}
        getLabel={id => labels.get(id)}
        options={ids}
        showLabel={false}
        isRowView={false}
      />
    )
  }

  render() {
    const { t, isMobileOnly } = this.props
    return (
      <div className={bc}>
        <div className={`${bc}__wrapper`}>
          <div className={`${bc}__left-part`}>
            <div className={`${bc}__back`}>
              <Link to="/dashboard" className={`${bc}__back-btn`}>
                <Back />
                <span className={`${bc}__back-text`}>{t('Back')}</span>
              </Link>
            </div>
            <div className={`${bc}__title`}>{t('user:My stories')}</div>
          </div>
          {!isMobileOnly && this.renderFilter()}
        </div>
        {isMobileOnly && this.renderFilter()}
      </div>
    )
  }
}

export default withTranslation()(StoriesHeader)
